import { render, staticRenderFns } from "./PackagePaymentMethod.vue?vue&type=template&id=b99b6bd4&scoped=true&"
import script from "./PackagePaymentMethod.vue?vue&type=script&lang=js&"
export * from "./PackagePaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./PackagePaymentMethod.vue?vue&type=style&index=0&id=b99b6bd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99b6bd4",
  null
  
)

export default component.exports